
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hnY2b", function(module, exports) {

$parcel$export(module.exports, "CustomHeaderFooter", () => $3dd008da82a309f1$export$ada7163111193fe6);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $dIouf = parcelRequire("dIouf");

var $ckbO7 = parcelRequire("ckbO7");

var $k3bZO = parcelRequire("k3bZO");
function $3dd008da82a309f1$export$ada7163111193fe6({ type: type }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ep3mz.PageSubscriber), null, ({ spaceKey: spaceKey, contentId: contentId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
            query: (0, $k3bZO.CustomHeaderAndFooterQuery),
            variables: {
                spaceKey: spaceKey
            }
        }, ({ loading: loading, error: error, data: data })=>{
            const settings = data?.space?.settings?.customHeaderAndFooter?.[type];
            if (loading || error || !settings?.html) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ckbO7.CustomHeaderFooterComponent), {
                spaUnfriendlyMacros: settings.spaUnfriendlyMacros,
                type: type,
                css: settings.css,
                js: settings.js,
                html: settings.html,
                key: contentId
            });
        })));
}

});
parcelRegister("ckbO7", function(module, exports) {

$parcel$export(module.exports, "CustomHeaderFooterComponent", () => $f471ae630ee83f86$export$4f9395cfec7bd640);
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $gwFzn = parcelRequire("gwFzn");

var $2p7B1 = parcelRequire("2p7B1");

var $inPa6 = parcelRequire("inPa6");

var $k5ycH = parcelRequire("k5ycH");
var $8SfNq = parcelRequire("8SfNq");

var $brpfO = parcelRequire("brpfO");

var $luv00 = parcelRequire("luv00");

var $lvV7v = parcelRequire("lvV7v");

var $4grSg = parcelRequire("4grSg");
const $f471ae630ee83f86$var$i18n = (0, $2nPZH.defineMessages)({
    unsupportedMacrosTitle: {
        id: "custom-header-footer.unsupported.macros.title",
        defaultMessage: "Unsupported macros"
    }
});
const $f471ae630ee83f86$export$4f9395cfec7bd640 = /*#__PURE__*/ (0, $gwFzn.memo)(({ spaUnfriendlyMacros: spaUnfriendlyMacros = [], type: type, js: js, css: css, html: html })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const intl = (0, $dBxQj.default)();
    const HeaderOrFooterComponent = type === (0, $lvV7v.CUSTOM_HEADER_FOOTER_TYPES).HEADER ? (0, $4grSg.StyledHeader) : (0, $4grSg.StyledFooter);
    const bodyRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createRef();
    const scriptRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createRef();
    // remove duplicates
    spaUnfriendlyMacros = Array.from(new Set(spaUnfriendlyMacros));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'customHeaderAndFooter',
                attributes: {
                    type: type === (0, $lvV7v.CUSTOM_HEADER_FOOTER_TYPES).HEADER ? 'header' : 'footer'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        type
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!scriptRef.current || !bodyRef.current) return;
        (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (scriptRef.current) (0, $k5ycH.loadResources)(scriptRef.current, js).then(()=>{
                if (bodyRef.current) (0, $brpfO.evalLegacyConnectInlineScripts)(bodyRef.current);
            });
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4grSg.StyledRoot), {
        "data-vc": "custom-header-footer",
        ...ssrPlaceholderIdProp
    }, spaUnfriendlyMacros.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4grSg.StyledUnsupportedMacro), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), {
        color: "var(--ds-icon-warning, #E56910)",
        label: intl.formatMessage($f471ae630ee83f86$var$i18n.unsupportedMacrosTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "custom-header-footer.unsupported.macros.list",
        defaultMessage: "The following macros are not currently supported in the {type}:",
        values: {
            type: type
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("ul", null, spaUnfriendlyMacros.map((macro)=>macro && macro.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", {
            key: macro.name
        }, macro.name)))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: css
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(HeaderOrFooterComponent, {
        "data-test-id": `custom-settings-${type}`,
        dangerouslySetInnerHTML: {
            __html: html
        },
        ref: bodyRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: scriptRef
    }));
});

});
parcelRegister("4grSg", function(module, exports) {

$parcel$export(module.exports, "StyledRoot", () => $ee636bb0fe7b35e9$export$901f7fd9c2a96dff);
$parcel$export(module.exports, "StyledUnsupportedMacro", () => $ee636bb0fe7b35e9$export$271656970d77ed00);
$parcel$export(module.exports, "StyledHeader", () => $ee636bb0fe7b35e9$export$579a1e9bab103f15);
$parcel$export(module.exports, "StyledFooter", () => $ee636bb0fe7b35e9$export$61905ae62c7860fb);
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $ee636bb0fe7b35e9$export$901f7fd9c2a96dff = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4dik7",
            __cmplp.className
        ])
    });
});
const $ee636bb0fe7b35e9$export$271656970d77ed00 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1skznkob",
            __cmplp.className
        ])
    });
});
const $ee636bb0fe7b35e9$export$579a1e9bab103f15 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_y3gn1h6o _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $ee636bb0fe7b35e9$export$61905ae62c7860fb = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkoahv _y3gn1h6o _1e0c1ule",
            __cmplp.className
        ])
    });
});

});


parcelRegister("k3bZO", function(module, exports) {

$parcel$export(module.exports, "CustomHeaderAndFooterQuery", () => $e54f84fdc9bae4a0$export$74bb7cb63c9c267c);

var $d2LG0 = parcelRequire("d2LG0");
const $e54f84fdc9bae4a0$export$74bb7cb63c9c267c = (0, $d2LG0.default)`query CustomHeaderAndFooterQuery($spaceKey:String){space(key:$spaceKey){id settings{customHeaderAndFooter{header{html js css spaUnfriendlyMacros{name}}footer{html js css spaUnfriendlyMacros{name}}}}}}`;

});



//# sourceMappingURL=CustomHeaderFooter.fad595e4.js.map
